import { erpAxios } from '..';

const addRacuni = async (data) => {
  const res = await erpAxios.post(`/racuni/addMultiple`, data);
  return res;
};

export default addRacuni;
